import { render } from "./ShareAndEarn.vue?vue&type=template&id=31d27c44&ts=true"
import script from "./ShareAndEarn.vue?vue&type=script&lang=ts"
export * from "./ShareAndEarn.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__